// Generated by scripts/generate-public-surface.ts. Do not edit.

import type {
  CountryValidator,
  ParsedBirthDate,
} from "../../types";

import { createValidator } from "#stdnum-runtime";

const civil: CountryValidator<"KW", ParsedBirthDate> =
  createValidator("kw.civil", 111);

export default civil;
export const compact = civil.compact;
export const format = civil.format;
export const validate = civil.validate;
export const generate = (): string =>
  civil.generate?.() ??
  (() => {
    throw new Error(
      "Validator kw.civil cannot generate values",
    );
  })();
export const parse = civil.parse;
